import React from "react";
import { useSnackBar } from "../../../hooks/useSnackBar";

// components imports
import PaymentList from "./Components/PaymentList/PaymentList";
import PendingPayments from "./Components/PendingPayments/PendingPayments";
import PaymentsSettings from "./Components/PaymentsSettings/PaymentsSettings";
import TabsComponent from "../../../Components/Common/TabsComponent";
import AdminTaxes from "./Components/Taxes/Taxes";
import StripePayouts from "./Components/Stripe Payouts/StripePayouts";
import MonthlyInvoices from "./Components/MonthlyInvoices/MonthlyInvoices";
import { useTranslation } from "react-i18next";

const Payments = () => {
  const { t } = useTranslation("admin");
  const [tab, setTab] = React.useState(0);
  const setSnack = useSnackBar();

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <div className="dispatcher__screen" style={{ maxWidth: "100%" , padding: "0px 5px"}}>
      <TabsComponent
        items={[
          {
            label: t("payments.payments"),
            style: { fontWeight: "bold" },
            value: 0,
          },
          {
            label: t("payments.pendingPayments"),
            style: { fontWeight: "bold" },
            value: 1,
          },
          {
            label: t("payments.paymentSettings"),
            style: { fontWeight: "bold" },
            value: 2,
          },
          {
            label: t("payments.monthlyInvoices"),
            style: { fontWeight: "bold" },
            value: 3,
          },
          { label: t("payments.taxes"), style: { fontWeight: "bold" }, value: 4 },
          { label: t("payments.stripePayouts"), style: { fontWeight: "bold" }, value: 5 },
        ]}
        tab={tab}
        handleTabChange={handleTabChange}
      />
      {tab === 0 && <PaymentList setSnack={setSnack} />}
      {tab === 1 && <PendingPayments setSnack={setSnack} />}
      {tab === 2 && <PaymentsSettings setSnack={setSnack} />}
      {tab === 3 && <MonthlyInvoices setSnack={setSnack} />}
      {tab === 4 && <AdminTaxes setSnack={setSnack} />}
      {tab === 5 && <StripePayouts setSnack={setSnack} />}
    </div>
  );
};

export default Payments;
